import { Link } from "react-router-dom";
import {
  Atom, Calculator, Dna, FlaskConical, Hammer, Zap,
  Wrench, Sun, Cpu, Cog, Building2, Microscope, ArrowUpRight,
} from "lucide-react";

const items = [
  { icon: Cog, name: "Ingeniería", desc: "Sistemas, mecánica, diseño funcional.", to: "/herramientas/quicktools" },
  { icon: Calculator, name: "Matemáticas", desc: "El lenguaje exacto del universo.", to: "/herramientas/canvas" },
  { icon: Atom, name: "Física", desc: "Fuerzas, energía, materia en movimiento.", to: "/herramientas/materials" },
  { icon: Dna, name: "Biología", desc: "La vida como ingeniería viviente.", to: "/herramientas/materials" },
  { icon: FlaskConical, name: "Química", desc: "Transformación de la materia.", to: "/herramientas/materials" },
  { icon: Microscope, name: "Ciencia", desc: "Método, hipótesis, experimentación.", to: "/herramientas/council" },
  { icon: Building2, name: "Construcción", desc: "Estructuras que sostienen mundos.", to: "/herramientas/materials" },
  { icon: Zap, name: "Electricidad", desc: "Circuitos, voltaje, control del rayo.", to: "/herramientas/arduino" },
  { icon: Wrench, name: "Plomería", desc: "Hidráulica, presión, fluidos vitales.", to: "/herramientas/quicktools" },
  { icon: Sun, name: "Renovables", desc: "Solar, eólica, geotérmica, biomasa.", to: "/herramientas/solar" },
  { icon: Cpu, name: "Fabricación 3D", desc: "Modelado, slicing, impresión aditiva.", to: "/herramientas/cad_bridge" },
  { icon: Hammer, name: "Oficios", desc: "Materiales sin máquina, manos al fuego.", to: "/herramientas/inventory" },
];

export const Disciplines = () => (
  <section id="disciplinas" className="relative py-32 border-t border-border">
    <div className="container">
      <SectionLabel index="02" title="Disciplinas" />
      <h2 className="font-serif-display text-4xl md:text-6xl font-light max-w-3xl mb-20 leading-tight">
        Doce fuegos. <span className="text-ember italic">Un solo método.</span>
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-border">
        {items.map((it) => (
          <Link
            key={it.name}
            to={it.to}
            className="group relative bg-card p-6 md:p-8 hover:bg-secondary/40 transition-colors duration-500 cursor-pointer block"
          >
            <div className="absolute top-0 left-0 h-px w-0 bg-ember group-hover:w-full transition-all duration-700" />
            <div className="flex items-center justify-between mb-6">
              <it.icon className="w-7 h-7 text-primary group-hover:scale-110 transition-transform duration-500" strokeWidth={1.5} />
              <ArrowUpRight className="w-4 h-4 text-muted-foreground/30 group-hover:text-primary group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
            </div>
            <h3 className="font-serif-display text-xl mb-2 group-hover:text-primary transition-colors">{it.name}</h3>
            <p className="text-xs text-muted-foreground leading-relaxed">{it.desc}</p>
            <span className="absolute top-4 right-4 font-mono-tech text-[9px] text-muted-foreground/40">
              {String(items.indexOf(it) + 1).padStart(2, "0")}
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export const SectionLabel = ({ index, title }: { index: string; title: string }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="font-mono-tech text-xs text-primary">{index}</span>
    <span className="h-px w-8 bg-primary/60" />
    <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{title}</span>
  </div>
);